import Comment from './Comment.jsx';

export default Comment;